<template>
    <page :loading="loading">
        <div slot="header" class="flex-row">
			<div class="flex-item page_header">
				<el-form size="small" :inline="true">
					<el-form-item>
						<el-button @click="table.form = {status: 1}, showDialog = true" type="primary" plain>添加保险分组</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>

        <page-table :datas="table.data" :page="table.search._page" :size="table.search._size" :total="table._count" @change="LoadDatas">
            <el-table-column prop="id"            				   label="ID" align="center" fixed="left"  width="60" />
			<el-table-column prop='name'                           label='分组名称' align='center'/>
			<el-table-column prop='created_at'                     label='创建时间' align='center'/>
			<el-table-column prop='status'                         label='状态' align='center'>
			    <template slot-scope="scope">
			    	<el-tag v-if="scope.row.status">开启</el-tag>
			    	<el-tag v-else type="danger">关闭</el-tag>
			    </template>
			</el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="120">
                <template slot-scope="scope">
                    <el-button @click="table.form = scope.row, showDialog = true" type="text" size="small">编辑</el-button>
                    <el-button @click="ActionDel(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </page-table>

        <el-dialog title="保险分组" :visible.sync="showDialog" width="35%">
        	<el-form label-width="100px">
        		<el-form-item label="分组名称">
        			<el-input v-model="table.form.name" placeholder="请输入名称"></el-input>
        		</el-form-item>
        		<el-form-item label="状态">
        			<el-switch v-model="table.form.status" :active-value="1" :inactive-value="0" active-color="#188fff" inactive-color="#e5e5e5"></el-switch>
        		</el-form-item>
        		<el-form-item>
        			<el-button type="primary" @click="ActionSave(table.form)">保存</el-button>
        			<el-button @click="showDialog = false, table.form = {}">取消</el-button>
        		</el-form-item>
        	</el-form>
        </el-dialog>
    </page>
</template>
<script>
export default {
    data(){
        return {
			showDialog: false,
            loading: false,
            table:{
                data: [],
                form: {},
                search: {
                    _page: 1,
                    _size: 20,
                },
            	_count: 0,
            },
        }
    },
    mounted() {
		this.LoadDatas();
    },
    methods: {
        /**
         * 获取数据列表
         * @param page 分页-当前页
         * @param limit 分页-每页数量
         * **/
        LoadDatas(page,limit){
            page && (this.table.search._page = page),limit && (this.table.search._size = limit),this.loading = true;
            this.$get('app-goods-group',this.table.search).then(res=>
            {   
                this.table.data = res.data, this.table._count = res.extra.pageInfo.count, this.loading = false;
            }).catch(err=>
            {
                this.$warning(err), this.loading = false;
            });
        },
        /**
         * 保存
         * @param item 要保存的数据
         * **/
        ActionSave(item){
            this.loading = true;
            this.$save('app-goods-group',item).then(res=>
            {
                this.loading = false, this.LoadDatas(), this.$success('操作成功'), this.showDialog = false;
            }).catch(err=>
            {
                this.loading = false , this.$warning(err);
            });
        },

        /**
         * 删除
         * @param item 要删除的数据
         * **/
        ActionDel(item){
            if( item.id ){
                this.loading = true;
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => {
                    this.$del('app-goods-group/'+item.id).then(res=>{
                        this.loading = false, this.LoadDatas(), this.$success('操作成功');
                    }).catch(err=>{
                        this.loading = false, this.$warning(err);
                    })
                }).catch(()=>{
                    this.loading = false;
                })
            }
        }
    },
}
</script>

<style lang="scss" scoped>
	.page_header {
		margin:10px 10px 0;
		position: absolute;
		z-index: 100;
	}
</style>